export default __webpack_public_path__ + "static/media/Silver clouds_primary (2).d894450a.jpg";